<template>
  <a-card :bordered="false">
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane key="1" tab="常用应用"><commonly /></a-tab-pane>
      <a-tab-pane key="2" tab="登录页配置"><loginPage></loginPage></a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import commonly from './components/commonly'
import loginPage from './components/loginPage'
export default {
  components:{commonly,loginPage}
};
</script>